import { GridDefaultCellTemplates } from "../../../components/components/Grid/grid-template";
import { SelectOption } from "../../../shared/components/input";
import { Button } from "primereact/button";
import { createEmptyCommissionRate, EMPTY_GUID } from "../Model/CompanyCommissionRate";
import { CommonUtility } from "../../../Services/CommonUtility";
import React from "react";
export default class CarrierCommissionService {
    private CommissionEditRowColumn = {
        CellTemplate: (cell: any) => {
            let disableButton = false;
            if (cell?.row?.original?.isGridInEditMode) {
                disableButton = true;
            }
            const params = cell.column.CellEditTemplateParameters;
            const editDisabled = disableButton || params?.disableEdit;
            const deleteDisabled = disableButton || params?.disableDelete;
            return (
                <div className="commission-action-btns">
                    <Button
                        icon="bi bi-pencil"
                        onClick={() => {
                            if (params?.cellClickHandler && !editDisabled) {
                                params.cellClickHandler(cell.row.original, cell.column, 'edit_row');
                            }
                        }}
                        disabled={editDisabled}
                        size="small"
                        tooltip="Edit"
                        rounded text
                        className="commission-action-btn"
                    />
                    <Button
                        icon="bi bi-trash"
                        onClick={() => {
                            if (params?.cellClickHandler && !deleteDisabled) {
                                params.cellClickHandler(cell.row.original, cell.column, 'delete_row');
                            }
                        }}
                        disabled={deleteDisabled}
                        size="small"
                        tooltip="Delete"
                        severity="danger"
                        rounded text
                        className="commission-action-btn"
                    />
                </div>
            );
        }
    }
    public getGridColumns = (
        onEditingCellDataChange: (row: any, column: any, value: any, additionalInfo: any) => void,
        cellClickHandler: (row: any, column: any, additionalData: any) => void,
        agencyOptions: SelectOption[],
        stateOptions: SelectOption[],
        policyTypeOptions: SelectOption[],
        marketTypeOptions: SelectOption[],
        businessTypeOptions: SelectOption[],
        planTypeOptions: SelectOption[],
        groupTypeOptions: SelectOption[],
        writingCompanyOptions: SelectOption[],
        agencyDirectOptions: SelectOption[],
        billCodeOptions: SelectOption[],
        disableEdit: boolean = false,
        disableDelete: boolean = false
    ) => {
        let columns: any[] = [
            {
                Header: 'Actions',
                accessor: 'enableGridRowEditing',
                hideColumnFilter: true,
                headerClassName: 'sticky-col sticky-col-header',
                cellClassName: 'sticky-col',
                Cell: (cell: any) => {
                    if (cell.row?.original?.enableGridRowEditing) {
                        return GridDefaultCellTemplates.SaveRowGridColumn.CellTemplate(cell);
                    }
                    return this.CommissionEditRowColumn.CellTemplate(cell);
                },
                CellEditTemplateParameters: { cellClickHandler: cellClickHandler, disableEdit: disableEdit, disableDelete: disableDelete },
                CellEditTDProperties: { className: "grd-edit-cell-td sticky-col" },
                width: 90,
            },
            {
                Header: 'Agency',
                accessor: 'agencyName',
                fieldName: 'agencyId',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: cell => <div><span title={cell.row?.original?.agencyName}>{cell.row?.original?.agencyName}</span></div>,
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: { options: agencyOptions, cellDataChangeHandler: onEditingCellDataChange, dropDownIconClassName: 'grd-edit-cell-select-icon', selectMainDivInvalidClassName: 'custom-dropdown--error-select-div' },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: "grd-edit-cell-td" },
                width: 200,
            },
            {
                Header: 'Policy Type',
                accessor: 'policyTypeName',
                fieldName: 'policyType',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: cell => <div><span title={cell.row?.original?.policyTypeName}>{cell.row?.original?.policyTypeName}</span></div>,
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: { options: policyTypeOptions, cellDataChangeHandler: onEditingCellDataChange, dropDownIconClassName: 'grd-edit-cell-select-icon' },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: "grd-edit-cell-td" },
                width: 160,
            },
            {
                Header: 'Agency Direct',
                accessor: 'agencyDirectDisplay',
                fieldName: 'agencyDirect',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: cell => <div><span title={cell.row?.original?.agencyDirectDisplay}>{cell.row?.original?.agencyDirectDisplay}</span></div>,
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: { options: agencyDirectOptions, cellDataChangeHandler: onEditingCellDataChange, dropDownIconClassName: 'grd-edit-cell-select-icon' },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: "grd-edit-cell-td" },
                width: 150,
            },
            {
                Header: 'Bill Code',
                accessor: 'billCodeDisplay',
                fieldName: 'billCode',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: cell => <div><span title={cell.row?.original?.billCodeDisplay}>{cell.row?.original?.billCodeDisplay}</span></div>,
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: { options: billCodeOptions, cellDataChangeHandler: onEditingCellDataChange, dropDownIconClassName: 'grd-edit-cell-select-icon' },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: "grd-edit-cell-td" },
                width: 150,
            },
            {
                Header: 'Min Age',
                accessor: 'minAgeDisplay',
                fieldName: 'minAge',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: cell => <div><span title={cell.row?.original?.minAgeDisplay}>{cell.row?.original?.minAgeDisplay}</span></div>,
                CellEditTemplate: GridDefaultCellTemplates.TextInputGridColumn.CellTemplate,
                CellEditTemplateParameters: { cellDataChangeHandler: onEditingCellDataChange, type: 'number', maxLength: 3, allowDecimal: false },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.TextInputGridColumn.ErrorHandler,
                CellEditTDProperties: { className: "grd-edit-cell-td" },
                width: 100,
            },
            {
                Header: 'Max Age',
                accessor: 'maxAgeDisplay',
                fieldName: 'maxAge',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: cell => <div><span title={cell.row?.original?.maxAgeDisplay}>{cell.row?.original?.maxAgeDisplay}</span></div>,
                CellEditTemplate: GridDefaultCellTemplates.TextInputGridColumn.CellTemplate,
                CellEditTemplateParameters: { cellDataChangeHandler: onEditingCellDataChange, type: 'number', maxLength: 3, allowDecimal: false },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.TextInputGridColumn.ErrorHandler,
                CellEditTDProperties: { className: "grd-edit-cell-td" },
                width: 100,
            },
            {
                Header: 'Market Type',
                accessor: 'marketTypeName',
                fieldName: 'marketType',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: cell => <div><span title={cell.row?.original?.marketTypeName}>{cell.row?.original?.marketTypeName}</span></div>,
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: { options: marketTypeOptions, cellDataChangeHandler: onEditingCellDataChange, dropDownIconClassName: 'grd-edit-cell-select-icon' },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: "grd-edit-cell-td" },
                width: 160,
            },
            {
                Header: 'Business Type',
                accessor: 'businessTypeName',
                fieldName: 'businessType',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: cell => <div><span title={cell.row?.original?.businessTypeName}>{cell.row?.original?.businessTypeName}</span></div>,
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: { options: businessTypeOptions, cellDataChangeHandler: onEditingCellDataChange, dropDownIconClassName: 'grd-edit-cell-select-icon' },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: "grd-edit-cell-td" },
                width: 160,
            },
            {
                Header: 'Plan Type',
                accessor: 'planTypeName',
                fieldName: 'planType',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: cell => <div><span title={cell.row?.original?.planTypeName}>{cell.row?.original?.planTypeName}</span></div>,
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: { options: planTypeOptions, cellDataChangeHandler: onEditingCellDataChange, dropDownIconClassName: 'grd-edit-cell-select-icon' },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: "grd-edit-cell-td" },
                width: 160,
            },
            {
                Header: 'Group Type',
                accessor: 'groupTypeName',
                fieldName: 'groupType',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: cell => <div><span title={cell.row?.original?.groupTypeName}>{cell.row?.original?.groupTypeName}</span></div>,
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: { options: groupTypeOptions, cellDataChangeHandler: onEditingCellDataChange, dropDownIconClassName: 'grd-edit-cell-select-icon' },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: "grd-edit-cell-td" },
                width: 160,
            },
            {
                Header: 'Writing Company',
                accessor: 'writingCompanyName',
                fieldName: 'writingCompanyId',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: cell => <div><span title={cell.row?.original?.writingCompanyName}>{cell.row?.original?.writingCompanyName}</span></div>,
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: { options: writingCompanyOptions, cellDataChangeHandler: onEditingCellDataChange, dropDownIconClassName: 'grd-edit-cell-select-icon' },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: "grd-edit-cell-td" },
                width: 200,
            },
            {
                Header: 'Effective Date',
                accessor: 'effectiveDateDisplay',
                fieldName: 'effectiveDate',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: cell => <div><span title={cell.row?.original?.effectiveDateDisplay}>{cell.row?.original?.effectiveDateDisplay}</span></div>,
                CellEditTemplate: GridDefaultCellTemplates.DateFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: { cellDataChangeHandler: onEditingCellDataChange },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.DateFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: "grd-edit-cell-td" },
                width: 170,
            },
            {
                Header: 'Geo Tier',
                accessor: 'geoTierDisplay',
                fieldName: 'geoTier',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: cell => <div><span title={cell.row?.original?.geoTierDisplay}>{cell.row?.original?.geoTierDisplay}</span></div>,
                CellEditTemplate: GridDefaultCellTemplates.TextInputGridColumn.CellTemplate,
                CellEditTemplateParameters: { cellDataChangeHandler: onEditingCellDataChange, type: 'number', allowDecimal: false },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.TextInputGridColumn.ErrorHandler,
                CellEditTDProperties: { className: "grd-edit-cell-td" },
                width: 100,
            },
            {
                Header: 'State',
                accessor: 'stateCodeDisplay',
                fieldName: 'stateCode',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: cell => <div><span title={cell.row?.original?.stateCodeDisplay}>{cell.row?.original?.stateCodeDisplay}</span></div>,
                CellEditTemplate: GridDefaultCellTemplates.SelectFieldGridColumn.CellTemplate,
                CellEditTemplateParameters: { options: stateOptions, cellDataChangeHandler: onEditingCellDataChange, dropDownIconClassName: 'grd-edit-cell-select-icon', selectMainDivInvalidClassName: 'custom-dropdown--error-select-div' },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.SelectFieldGridColumn.ErrorHandler,
                CellEditTDProperties: { className: "grd-edit-cell-td" },
                width: 130,
            },
            {
                Header: 'County',
                accessor: 'countyDisplay',
                fieldName: 'county',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: cell => <div><span title={cell.row?.original?.countyDisplay}>{cell.row?.original?.countyDisplay}</span></div>,
                CellEditTemplate: GridDefaultCellTemplates.TextInputGridColumn.CellTemplate,
                CellEditTemplateParameters: { cellDataChangeHandler: onEditingCellDataChange, maxLength: 100 },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.TextInputGridColumn.ErrorHandler,
                CellEditTDProperties: { className: "grd-edit-cell-td" },
                width: 140,
            },
            {
                Header: 'Zip Code',
                accessor: 'zipCodeDisplay',
                fieldName: 'zipCode',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: cell => <div><span title={cell.row?.original?.zipCodeDisplay}>{cell.row?.original?.zipCodeDisplay}</span></div>,
                CellEditTemplate: GridDefaultCellTemplates.TextInputGridColumn.CellTemplate,
                CellEditTemplateParameters: { cellDataChangeHandler: onEditingCellDataChange, type: 'number', maxLength: 10, allowDecimal: false },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.TextInputGridColumn.ErrorHandler,
                CellEditTDProperties: { className: "grd-edit-cell-td" },
                width: 110,
            },
            {
                Header: 'Rate (%)',
                accessor: 'rateDisplay',
                fieldName: 'rate',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: cell => <div><span title={cell.row?.original?.rateDisplay}>{cell.row?.original?.rateDisplay}</span></div>,
                CellEditTemplate: GridDefaultCellTemplates.TextInputGridColumn.CellTemplate,
                CellEditTemplateParameters: { cellDataChangeHandler: onEditingCellDataChange, type: 'number', maxLength: 6 },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.TextInputGridColumn.ErrorHandler,
                CellEditTDProperties: { className: "grd-edit-cell-td" },
                width: 100,
            },
            {
                Header: 'Notes',
                accessor: 'notesDisplay',
                fieldName: 'notes',
                Cell: GridDefaultCellTemplates.EditableGridColumn.CellTemplate,
                CellViewTemplate: cell => <div><span title={cell.row?.original?.notesDisplay}>{cell.row?.original?.notesDisplay}</span></div>,
                CellEditTemplate: GridDefaultCellTemplates.TextInputGridColumn.CellTemplate,
                CellEditTemplateParameters: { cellDataChangeHandler: onEditingCellDataChange, maxLength: 400 },
                CellEditTemplateErrorHandler: GridDefaultCellTemplates.TextInputGridColumn.ErrorHandler,
                CellEditTDProperties: { className: "grd-edit-cell-td" },
                width: 250,
            },
        ];
        return columns;
    }
    public getNewRow = (companyId: string): any => {
        let newRow: any = createEmptyCommissionRate(companyId);
        newRow.enableGridRowEditing = true;
        newRow.isGridInEditMode = false;
        newRow.editingRow = { ...newRow };
        newRow.agencyName = '';
        newRow.stateCodeDisplay = '';
        newRow.policyTypeName = '';
        newRow.agencyDirectDisplay = '';
        newRow.billCodeDisplay = '';
        newRow.minAgeDisplay = '';
        newRow.maxAgeDisplay = '';
        newRow.geoTierDisplay = '';
        newRow.marketTypeName = '';
        newRow.businessTypeName = '';
        newRow.planTypeName = '';
        newRow.groupTypeName = '';
        newRow.writingCompanyName = '';
        newRow.rateDisplay = '';
        newRow.effectiveDateDisplay = '';
        newRow.countyDisplay = '';
        newRow.zipCodeDisplay = '';
        newRow.notesDisplay = '';
        return newRow;
    }
    public enrichDisplayFields = (row: any, agencies: any[], policyTypes: any[], marketTypes: any[], businessTypes: any[], planTypes: any[], groupTypes: any[], writingCompanies: any[], _usStates: any[]) => {
        row.agencyName = this.getLookupLabel(agencies, row.agencyId);
        row.stateCodeDisplay = row.stateCode || '';
        row.policyTypeName = this.getLookupLabel(policyTypes, row.policyType);
        row.agencyDirectDisplay = row.agencyDirect || '';
        row.billCodeDisplay = row.billCode || '';
        row.minAgeDisplay = row.minAge !== null && row.minAge !== undefined ? String(row.minAge) : '';
        row.maxAgeDisplay = row.maxAge !== null && row.maxAge !== undefined ? String(row.maxAge) : '';
        row.geoTierDisplay = row.geoTier !== null && row.geoTier !== undefined ? String(row.geoTier) : '';
        row.marketTypeName = this.getLookupLabel(marketTypes, row.marketType);
        row.businessTypeName = this.getLookupLabel(businessTypes, row.businessType);
        row.planTypeName = this.getLookupLabel(planTypes, row.planType);
        row.groupTypeName = this.getLookupLabel(groupTypes, row.groupType);
        row.writingCompanyName = this.getLookupLabel(writingCompanies, row.writingCompanyId);
        row.rateDisplay = row.rate !== null && row.rate !== undefined ? `${row.rate}%` : '';
        row.effectiveDate = row.effectiveDate ? new Date(row.effectiveDate) : null;
        row.effectiveDateDisplay = row.effectiveDate ? CommonUtility.formateDate(row.effectiveDate) : '';
        row.countyDisplay = row.county || '';
        row.zipCodeDisplay = row.zipCode || '';
        row.notesDisplay = row.notes || '';
    }
    public validateRow = (originalRow: any): any => {
        let errors: any = {};
        let editingRow = originalRow.editingRow;
        if (!editingRow) return errors;
        if (!editingRow.agencyId) {
            errors.agencyId = { warningText: 'Agency is required' };
        }
        if (!editingRow.stateCode) {
            errors.stateCode = { warningText: 'State is required' };
        }
        if (editingRow.minAge !== null && editingRow.minAge !== undefined && editingRow.minAge !== '') {
            const val = Number(editingRow.minAge);
            if (isNaN(val) || val < 0 || val > 999) {
                errors.minAge = { warningText: 'Must be 0-999' };
            }
        }
        if (editingRow.maxAge !== null && editingRow.maxAge !== undefined && editingRow.maxAge !== '') {
            const val = Number(editingRow.maxAge);
            if (isNaN(val) || val < 0 || val > 999) {
                errors.maxAge = { warningText: 'Must be 0-999' };
            }
        }
        if (editingRow.minAge && editingRow.maxAge) {
            if (Number(editingRow.maxAge) < Number(editingRow.minAge)) {
                errors.maxAge = { warningText: 'Max Age must be >= Min Age' };
            }
        }
        if (editingRow.rate !== null && editingRow.rate !== undefined && editingRow.rate !== '') {
            const val = Number(editingRow.rate);
            if (isNaN(val) || val < 0 || val > 100) {
                errors.rate = { warningText: 'Must be 0-100' };
            }
        }
        if (editingRow.zipCode !== null && editingRow.zipCode !== undefined && editingRow.zipCode !== '') {
            if (!/^\d{1,10}$/.test(editingRow.zipCode)) {
                errors.zipCode = { warningText: 'Zip must be up to 10 digits' };
            }
        }
        return errors;
    }
    private getLookupLabel = (list: any[], id: string | null): string => {
        if (!id) return '';
        const item = list.find((l: any) => l.id === id || l.value === id || l.lookupCode === id);
        return item?.lookupValue || item?.name || item?.label || '';
    }
}
